import MainCard from '../components/MainCard';
import config from '../utils/config'; 
import React, { useState, useEffect } from 'react'; 
import { useAuth } from '../utils/AuthContext/AuthContext';

function Profile() {
    const [userProfile, setUserProfile] = useState({ name: '', email: '', phone: '', address: '' }); 
    const [loading, setLoading] = useState(true); 
    const [error, setError] = useState(''); 
    const [isModified, setIsModified] = useState(false); 
    const { token, user } = useAuth();

    // console.log("user", user);

    useEffect(() => {
        const userId = user._id || user.id;
        if (!user || !userId) {
            setError('User not authenticated');
            setLoading(false);
            return;
        }
        async function fetchData() {
            try {
                const response = await fetch(`${config.apiBaseUrl}/profile/${userId}`, { // Use user.id as userId
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    }
                });
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                const data = await response.json();
                setUserProfile(data);
            } catch (error) {
                setError(error.message);
            } finally {
                setLoading(false);
            }
        }

        fetchData();
    }, [token, user]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setUserProfile(prevState => ({
          ...prevState,
          [name]: value
        }));
        setIsModified(true);
      };
    
      const handleCancel = () => {
        setIsModified(false);
        // Re-fetch the user profile to reset the form
        async function fetchData() {
            try {
                const response = await fetch(`${config.apiBaseUrl}/profile/${user.id}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    }
                });
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                const data = await response.json();
                setUserProfile(data);
            } catch (error) {
                setError(error.message);
            }
        }

        fetchData();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(`${config.apiBaseUrl}/profile/${user.id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(userProfile)
            });
            if (!response.ok) {
                throw new Error('Failed to update profile');
            }
            alert('Profile updated successfully');
            setIsModified(false);
        } catch (error) {
            setError('Failed to update profile');
        }
    };
    
      if (loading) return <div>Loading...</div>;
      if (error) return <div>{error}</div>;

return (
        <div className="w-[375px] h-screen md:h-[750px] md:w-[750px] flex flex-col justify-start items-center">
            <MainCard>
            <h1 className="text-black text-[24px] md:text-[34px] w-full font-semibold font-['Inter'] mb-3">Profile</h1>
            <form onSubmit={handleSubmit} className='w-[300px] md:w-[450px] h-auto justify-between gap-3 items-start flex flex-col py-4'>
                <div className="flex flex-col text-left justify-start items-start w-[350px] md:w-[750px]">
                    <div className="w-[350px] justify-between gap-2 items-start flex flex-col">
                        <span className='text-sm text-slate-600'>
                            First Name: 
                        </span>
                    </div>
                    <input 
                        className={`py-1 px-[1px] md:px-3 h-[39px] rounded-md border w-[300px] md:w-[450px] border-slate-300`}
                        type="text" 
                        name="firstName" 
                        value={userProfile.firstName}
                        onChange={handleChange} 
                    />
                </div>
                <div className="flex flex-col text-left justify-start items-start w-[350px] md:w-[750px]">
                        <div className="w-[350px] justify-between gap-2 items-start flex flex-col">
                            <span className='text-sm text-slate-600'>
                                Last Name:
                            </span>
                        </div>
                        <input
                            className={`py-1 px-[1px] md:px-3 h-[39px] rounded-md border w-[300px] md:w-[450px] border-slate-300`}
                            type="text"
                            name="lastName"
                            value={userProfile.lastName}
                            onChange={handleChange}
                        />
                    </div>
                <div className="flex flex-col text-left justify-start items-start w-[350px] md:w-[750px]">
                    <div className="w-[350px] justify-between gap-2 items-start flex flex-col">
                        <span className='text-sm text-slate-600'>
                            Email: 
                        </span>
                    </div>
                    <input 
                        className={`py-1 px-[1px] md:px-3 h-[39px] rounded-md border w-[300px] md:w-[450px] border-slate-300`}
                        type="text" 
                        name="email" 
                        value={userProfile.email}
                        onChange={handleChange} 
                    />
                </div>
                {/* PHONE NUMBER */}
                <div className="flex flex-col text-left justify-start items-start w-[350px] md:w-[750px]">
                    <div className="w-[350px] justify-between gap-2 items-start flex flex-col">
                        <span className='text-sm text-slate-600'>
                            Phone Number: 
                        </span>
                    </div>
                    <input 
                        className={`py-1 px-[1px] md:px-3 h-[39px] rounded-md border w-[300px] md:w-[450px] border-slate-300`}
                        type="text" 
                        name="phone" 
                        value={userProfile.phone}
                        onChange={handleChange} 
                    />
                </div>
                {/* ADDRESS */}
                <div className="flex flex-col text-left justify-start items-start w-[350px] md:w-[750px]">
                    <div className="w-[350px] justify-between gap-2 items-start flex flex-col">
                        <span className='text-sm text-slate-600'>
                            Address: 
                        </span>
                    </div>
                    <input 
                        className={`py-1 px-[1px] md:px-3 h-[39px] rounded-md border w-[300px] md:w-[450px] border-slate-300`}
                        type="text" 
                        name="address" 
                        value={userProfile.address}
                        onChange={handleChange} 
                    />
                </div>
                {isModified && (
                        <div className="flex w-full justify-between gap-2 my-4">
                            <button type="button" onClick={handleCancel} className="px-4 py-2 w-[125px] bg-gray-300 hover:slate-600 rounded-md">Cancel</button>
                            <button type="submit" className="px-4 py-2 w-[125px] bg-shi-green text-white rounded-md hover:bg-green-950">Save</button>
                        </div>
                    )}
            </form>
            </MainCard>
        </div>
    )
}
export default Profile; 